import React, { useEffect, useRef, useState } from "react";
import "./NextHealthConcernsSurvey.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  updateSurveyData,
  updateSurveyPage,
} from "../../../../../redux/actions/survey";
import SurveyHero from "../../../../components/Survey/SurveyHero/SurveyHero";
import { Box } from "@mui/material";
import HealthConcernText from "../../../../components/Survey/HealthConcernText/HealthConcernText";
import getThemes from "../../../../../constants/colors/getTheme";
import Button from "../../../../components/Comon/Button/Button";
import LinkText from "../../../../components/Comon/LinkText/LinkText";
import ScoreChangePromptModal from "../../../../components/Survey/ScoreChangePromptModal";
import ScaleSwitchModal from "../../../../components/Survey/ScaleSwitchModal";

const NextHealthConcernsSurvey = ({
  showGlobalSnackbar,
  survey,
  i18n,
  app,
}) => {
  const [newScale, setNewScale] = useState(undefined);
  useEffect(() => {
   if(survey?.previousSurveyData?.scaleType || survey?.data?.scaleType){
      setNewScale((survey?.previousSurveyData?.scaleType ?? survey?.data?.scaleType) === 'zero_scale')
    }
  }, [survey]);


  const [concerns, setConcerns] = useState([]);
  const [themeColor, setThemeColor] = useState([]);
  const [scorePromptShown, setScorePromptShown] = useState(false);
  const scorePromptShownRef = useRef(false);
  const [scorePrompt, setScorePrompt] = useState({
    open: false,
    index: null,
    previousRate: null,
    currentRate: null,
  });
  const [showScaleSwitchModal, setShowScaleSwitchModal] = useState(false);

  const navigate = useNavigate();
  const { code } = useParams();
  const { previousId } = useParams();
  const dispatch = useDispatch();

  const getPreviousData = (concern) => {
    if (concern === null) {
      return i18n.t("notAnswered");
    } else if (concern.length === 0) {
      return i18n.t("notAnswered");
    } else {
      return concern;
    }
  };

  const getHealtConcernsForCurrentLanguage = () => {
    return survey?.settings?.clinic?.healthConcerns.find(
      (item) => item.language.id === survey?.settings?.language?.id
    );
  };

  const getLifeImpactForCurrentLanguage = () => {
    return survey?.settings?.clinic?.lifeImpacts.find(
      (item) => item.language.id === survey?.settings?.language?.id
    );
  };

  const hasPreviousConcernData = (concernValue, rateValue) => {
    const hasConcernText =
      typeof concernValue === "string"
        ? concernValue.trim().length > 0
        : concernValue !== null && concernValue !== undefined;
    const hasRate = rateValue !== null && rateValue !== undefined;

    return hasConcernText || hasRate;
  };

  const initialConcerns = [
    {
      name: "firstHealthConcern",
      topText: getHealtConcernsForCurrentLanguage()?.question1Subtitle,
      // headline: getHealtConcernsForCurrentLanguage()?.question1Title,
      // text: getHealtConcernsForCurrentLanguage()?.question1Description,
      leftOption: getHealtConcernsForCurrentLanguage()?.question1LowScale,
      rightOption: getHealtConcernsForCurrentLanguage()?.question1HighScale,

      // topText: getHealtConcernsForCurrentLanguage()?.question1Subtitle,
      // headline: i18n.t("ratePreviousConcern", {order: i18n.t("first")}) + (survey.previousSurveyData.healthConcernsFirstConcern === null || survey.previousSurveyData.healthConcernsFirstConcern.length) ? i18n.t("ratePreviousConcern", {order: i18n.t("first")}) + i18n.t("notAnswered") : survey.previousSurveyData.healthConcernsFirstConcern,
      headline:
          getHealtConcernsForCurrentLanguage()?.nextQuestion1Title+ " " +getHealtConcernsForCurrentLanguage()?.question1Title?.toLowerCase()+": " +
        getPreviousData(survey.previousSurveyData.healthConcernsFirstConcern),
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.healthConcernsFirstRate,
      }),
      lastTimeRate: survey.previousSurveyData.healthConcernsFirstRate,
      // leftOption: getHealtConcernsForCurrentLanguage()?.question1LowScale,
      // rightOption: getHealtConcernsForCurrentLanguage()?.question1HighScale,
      concern: survey.previousSurveyData.healthConcernsFirstConcern,
      concernRate:
        survey.data &&
        survey.data.healthConcerns &&
        survey.data?.healthConcerns[0]?.concernRate !== undefined
          ? survey.data.healthConcerns[0].concernRate
          : undefined,
    },
    {
      name: "secondHealthConcern",
      topText: "",
      // headline: getHealtConcernsForCurrentLanguage()?.question2Title,
      // text: getHealtConcernsForCurrentLanguage()?.question2Description,
      leftOption: getHealtConcernsForCurrentLanguage()?.question2LowScale,
      rightOption: getHealtConcernsForCurrentLanguage()?.question2HighScale,

      // topText: "",
      headline:
          getHealtConcernsForCurrentLanguage()?.nextQuestion2Title + " " +getHealtConcernsForCurrentLanguage()?.question2Title?.toLowerCase()+": "+
        getPreviousData(survey.previousSurveyData.healthConcernsSecondConcern),
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.healthConcernsSecondRate,
      }),
      lastTimeRate: survey.previousSurveyData.healthConcernsSecondRate,
      // leftOption: getHealtConcernsForCurrentLanguage()?.question2LowScale,
      // rightOption: getHealtConcernsForCurrentLanguage()?.question2HighScale,
      concern: survey.previousSurveyData.healthConcernsSecondConcern,
      concernRate:
        survey.data &&
        survey.data.healthConcerns &&
        survey.data?.healthConcerns[1]?.concernRate !== undefined
          ? survey.data.healthConcerns[1].concernRate
          : undefined,
    },
    {
      name: "thirdHealthConcern",
      topText: "",
      // headline: getHealtConcernsForCurrentLanguage()?.question3Title,
      // text: getHealtConcernsForCurrentLanguage()?.question3Description,
      leftOption: getHealtConcernsForCurrentLanguage()?.question3LowScale,
      rightOption: getHealtConcernsForCurrentLanguage()?.question3HighScale,

      // topText: "",
      headline:
          getHealtConcernsForCurrentLanguage()?.nextQuestion3Title+ " " +getHealtConcernsForCurrentLanguage()?.question3Title?.toLowerCase()+": " +
        getPreviousData(survey.previousSurveyData.healthConcernsThirdConcern),
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.healthConcernsThirdRate,
      }),
      lastTimeRate: survey.previousSurveyData.healthConcernsThirdRate,
      // leftOption: getHealtConcernsForCurrentLanguage()?.question3LowScale,
      // rightOption: getHealtConcernsForCurrentLanguage()?.question3HighScale,
      concern: survey.previousSurveyData.healthConcernsThirdConcern,
      concernRate:
        survey.data &&
        survey.data.healthConcerns &&
        survey.data?.healthConcerns[2]?.concernRate !== undefined
          ? survey.data.healthConcerns[2].concernRate
          : undefined,
    },
    {
      name: "fourthHealthConcern",
      topText: getLifeImpactForCurrentLanguage()?.question1Subtitle,
      // headline: getLifeImpactForCurrentLanguage()?.question1Title,
      // text: getLifeImpactForCurrentLanguage()?.question1Description,
      leftOption: getLifeImpactForCurrentLanguage()?.question1LowScale,
      rightOption: getLifeImpactForCurrentLanguage()?.question1HighScale,

      // topText: getLifeImpactForCurrentLanguage()?.question1Subtitle,
      headline:
        getLifeImpactForCurrentLanguage()?.question1Title +
        " " +
        getPreviousData(survey.previousSurveyData.healthConcernsFourthConcern),
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.healthConcernsFourthRate,
      }),
      lastTimeRate: survey.previousSurveyData.healthConcernsFourthRate,
      // leftOption: getLifeImpactForCurrentLanguage()?.question1LowScale,
      // rightOption: getLifeImpactForCurrentLanguage()?.question1HighScale,
      concern: survey.previousSurveyData.healthConcernsFourthConcern,
      concernRate:
        survey.data &&
        survey.data.healthConcerns &&
        survey.data?.healthConcerns[3]?.concernRate !== undefined
          ? survey.data.healthConcerns[3].concernRate
          : undefined,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(updateSurveyPage(1));
  }, []);

  useEffect(() => {
    if (
      !hasPreviousConcernData(
        survey.previousSurveyData.healthConcernsThirdConcern,
        survey.previousSurveyData.healthConcernsThirdRate
      )
    ) {
      const index = initialConcerns.findIndex(
        (c) => c.name === "thirdHealthConcern"
      );
      if (index !== -1) {
        initialConcerns[index].visible = false;
      }
    }

    if (
      !hasPreviousConcernData(
        survey.previousSurveyData.healthConcernsSecondConcern,
        survey.previousSurveyData.healthConcernsSecondRate
      )
    ) {
      const index = initialConcerns.findIndex(
        (c) => c.name === "secondHealthConcern"
      );
      if (index !== -1) {
        initialConcerns[index].visible = false;
      }
    }

    if (
      !hasPreviousConcernData(
        survey.previousSurveyData.healthConcernsFourthConcern,
        survey.previousSurveyData.healthConcernsFourthRate
      )
    ) {
      const index = initialConcerns.findIndex(
        (c) => c.name === "fourthHealthConcern"
      );
      if (index !== -1) {
        initialConcerns[index].visible = false;
      }
    }

    setConcerns(initialConcerns);

    if (survey.data == null) {
      survey.data = { healthConcerns: initialConcerns };
    } else {
      survey.data.healthConcerns = initialConcerns;
    }
    dispatch(updateSurveyData(survey.data));
    setScorePromptShown(false);
    scorePromptShownRef.current = false;
    setScorePrompt({
      open: false,
      index: null,
      previousRate: null,
      currentRate: null,
    });
  }, []);

  useEffect(() => {
    setThemeColor(getThemes("mainColor", app.appTheme));
  }, [app]);

  const nextPage = () => {
    if (concerns[0].concernRate === undefined || concerns[0].concernRate === null) {
      scrollTo();
      showGlobalSnackbar(i18n.t("pleaseCompleteFirstConcern"), 2000);

      return;
    }

    if (shouldShowScaleSwitchModal) {
      setShowScaleSwitchModal(true);
      return;
    }
    goToGlobalImprovements();
  };

  const goToGlobalImprovements = () => {
    dispatch(updateSurveyPage(2));
    navigate("/survey-next/" + code + "/" + previousId + "/global-improvements");
  };

  const previousPage = () => {
    navigate("/survey-next/" + code + "/" + previousId);
  };

  const updateConcern = (index, value, type) => {
    const nextConcerns = concerns.map((concern, concernIndex) =>
      concernIndex === index
        ? {
            ...concern,
            [type === "text" ? "concern" : "concernRate"]: value,
          }
        : concern
    );

    if (type === "rate" && !scorePromptShownRef.current) {
      const previousRate = Number(nextConcerns[index]?.lastTimeRate);
      const currentRate = Number(value);
      const hasValidRates =
        Number.isFinite(previousRate) && Number.isFinite(currentRate);
      const hasNegativeSwing =
        hasValidRates &&
        ((healthConcernScaleVariant === "red_to_green" &&
          previousRate - currentRate >= 2) ||
          (healthConcernScaleVariant === "green_to_red" &&
            currentRate - previousRate >= 2));

      if (hasNegativeSwing) {
        scorePromptShownRef.current = true;
        setScorePromptShown(true);
        setConcerns(nextConcerns);
        setScorePrompt({
          open: true,
          index,
          previousRate,
          currentRate,
        });
        return;
      }
    }

    setConcerns(nextConcerns);

    if (survey.data == null) {
      survey.data = { healthConcerns: nextConcerns };
    } else {
      survey.data.healthConcerns = nextConcerns;
    }
    dispatch(updateSurveyData(survey.data));
  };

  const closeScorePrompt = () => {
    if (survey.data == null) {
      survey.data = { healthConcerns: concerns };
    } else {
      survey.data.healthConcerns = concerns;
    }
    dispatch(updateSurveyData(survey.data));
    setScorePrompt((prev) => ({ ...prev, open: false }));
  };

  const changeScoreAnswer = () => {
    if (scorePrompt.index === null || scorePrompt.index === undefined) {
      closeScorePrompt();
      return;
    }

    const nextConcerns = concerns.map((concern, concernIndex) =>
      concernIndex === scorePrompt.index
        ? { ...concern, concernRate: undefined }
        : concern
    );

    setConcerns(nextConcerns);

    if (survey.data == null) {
      survey.data = { healthConcerns: nextConcerns };
    } else {
      survey.data.healthConcerns = nextConcerns;
    }
    dispatch(updateSurveyData(survey.data));
    closeScorePrompt();
  };

  const scrollTo = () => {
    const element = document.getElementById(concerns[0].name);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };
  const healthConcernScaleVariant =
    survey?.settings?.healthConcernScaleDesign === "red_to_green"
      ? "red_to_green"
      : "green_to_red";
  const globalImprovementsScaleVariant = "red_to_green";
  const shouldShowScaleSwitchModal =
    healthConcernScaleVariant !== "red_to_green";

  return (
    <div className="ThirdScreenSurvey">
      <ScoreChangePromptModal
        open={scorePrompt.open}
        previousRate={scorePrompt.previousRate}
        currentRate={scorePrompt.currentRate}
        onConfirm={closeScorePrompt}
        onChangeAnswer={changeScoreAnswer}
      />
      <ScaleSwitchModal
        open={showScaleSwitchModal}
        onConfirm={goToGlobalImprovements}
        fromScaleVariant={healthConcernScaleVariant}
        toScaleVariant={globalImprovementsScaleVariant}
      />
      <SurveyHero
        // step={i18n.t("step") + " 1"}
        headline={getHealtConcernsForCurrentLanguage()?.nextTitle}
        text={getHealtConcernsForCurrentLanguage()?.nextDesc}
        videoLink={getHealtConcernsForCurrentLanguage()?.nextVideoUrl}
        buttonText={i18n.t("next")}
        clickedButton={() => scrollTo()}
        app={app}
        surveyType={survey?.settings?.type}
      />

      <div className={"concernsContainer"}>
        {concerns.map((concern, index) => {
          if (concern.visible === false) {
            return null;
          }

          return (
            <div className={"concernContainer"} key={index}>
              <HealthConcernText
                newScale={newScale}
                scaleVariant={healthConcernScaleVariant}
                setConcernText={(value) => updateConcern(index, value, "text")}
                setConcernRate={(value) => updateConcern(index, value, "rate")}
                mandatory={concern.mandatory}
                text={concern.text}
                concernRate={concern.concernRate}
                topText={concern.topText}
                headline={concern.headline}
                themeColor={themeColor}
                hasTextInput={false}
                leftOption={concern.leftOption}
                rightOption={concern.rightOption}
                i18n={i18n}
                id={concern.name}
                concernText={concern.concern}
                lastTimeRate={concern.lastTimeRate}
              />
            </div>
          );
        })}
      </div>
      <div className={"buttonsContainer"}>
        <div className={"nextContainer"} onClick={() => nextPage()}>
          <Button color={themeColor} mode={"small"} text={i18n.t("next")} />
        </div>
        <div className={"previousContainer"} onClick={() => previousPage()}>
          <LinkText text={i18n.t("previous")} />
        </div>
      </div>
    </div>
  );
};

export default NextHealthConcernsSurvey;
